import { Button } from 'reactstrap'
import { useHistory } from 'react-router'
import { logout } from './../../../api/auth'
import UserContext from '../../../store/userContext'
import './header.scss'

const Header = () => {
  let history = useHistory()
  return (
    <div className="header-container">
      <div className="header-container__headerbox">
        <h4>Supervision Visit</h4>
        <UserContext.Consumer>
          {({ getUserInfo }) => (
            <h6>{getUserInfo()}</h6>
          )}
        </UserContext.Consumer>
      </div>
      <div className="header-container__actions">
        <Button
          onClick={() => {
            if (logout()) {
              history.replace('/')
            }
          }}
        >
          Logout
        </Button>
      </div>
    </div>
  )
}

export default Header
